<template>
  <section class="preview">
    <form novalidate @submit.prevent="crear">
        
      <mdb-input
        label="Nombre de rol"
        class="mb-3 mt-0"
        v-model="name"
        required
        invalidFeedback="Coloca el nombre"
      ></mdb-input>

      <label>Aplicar rol a</label>
      <multiselect
        v-model="aplyRoleToSelected"
        placeholder="aplicar rol para"
        class="mb-3"
        label="name"
        track-by="id"
        :options="aplyRoleTo"
        :multiple="false"
      ></multiselect>

      <label>Cuenta business</label>
      <multiselect
        v-model="accountSelected"
        placeholder="Seleccione una cuenta business"
        label="name"
        class="mb-3"
        track-by="id"
        :options="accounts"
        :multiple="false"
      ></multiselect>

      <div class="text-center">
        <mdb-btn type="submit" color="primary" :disabled="isLoading">
          <span v-if="!isLoading">Crear</span>
          <semipolar-spinner :animation-duration="2000" :size="30" color="#ffffff" v-if="isLoading"></semipolar-spinner>
        </mdb-btn>
      </div>
    </form>
  </section>
</template>

<script>
import { mdbInput, mdbBtn } from "mdbvue";
import { SemipolarSpinner } from "epic-spinners";
import Multiselect from "vue-multiselect";
import store from "../../store";
export default {
  name: "modal-2",
  components: {
    mdbInput,
    mdbBtn,
    SemipolarSpinner,
    Multiselect
  },
  props: {
    onClick: Function
  },
  data: () => {
    return {
      isLoading: false,
      name: "",
      aplyRoleToSelected: {},
      accountSelected: {},
      aplyRoleTo: [
        { name: "Todas las campañas activas", id: "1" },
        { name: "Todas las campañas pausadas", id: "2" }
      ],
      accounts: []
    };
  },
  async mounted() {
    var respuesta = await this.getBusinessAccounts();
  },
  methods: {
    crear(event) {
      event.target.classList.add("was-validated");
      var { name, aplyRoleToSelected, accountSelected } = this;
      this.isLoading = true;
      if (name == "") {
        this.isLoading = false;
      } else {
        var rule = {
          name,
          aplyRoleTo: aplyRoleToSelected,
          account: accountSelected,
          id: Math.random()
        };
        store.dispatch("newRule", rule).then(() => {
          this.name = "";
          this.onClick();
          this.isLoading = false;
        });
      }
    },
    async getBusinessAccounts() {
      var accounts = store.getters.getBusinessAccounts;
      if (accounts.length == 0) {
        this.isLoading = true;
        await store.dispatch("getBusinessAccounts").then(() => {
          accounts = store.getters.getBusinessAccounts;
          this.accounts = accounts;
          return;
        });
      } else {
        this.accounts = accounts;
        return;
      }
    }
  }
};
</script>

<style scoped>
</style>